import React from 'react'
import Link from 'next/link'
import Image from 'next/image';
import SectionHeading from '../../Common/SectionHeading';

export default function AdvanceSection({ data = null }) {
    return (
<>
            {(data) &&        
                <>
                    <section className="flex flex-col justify-center w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-10">
                        <div className="grid grid-cols-12 gap-4">
                            <div className='col-span-12 md:col-span-6'>
                                <div className="grid grid-cols-12 gap-4">
                                    {data.cards.map((item, index) => (
                                        <div key={index} className='col-span-12 md:col-span-6'>
                                            <div className="h-full p-8 text-center bg-white rounded-lg shadow-lg dark:bg-gray-600">
                                                <div className="w-12 h-12 pb-2 mx-auto icon">
                                                    <Image priority={false}
                                                        width={2000}
                                                        height={2000}
                                                        src={process.env.IMG_CDN+item?.imageSrc}
                                                        alt={item?.altText ? item?.altText : item?.title ? item?.title : 'DelveInsight'}
                                                        className="w-full h-full"
                                                    />
                                                </div>
                                                <h3 className="text-lg font-semibold">{item?.title}</h3>
                                                <p className='my-0'>{item?.shortDescription}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className='col-span-12 md:col-span-6'>
                                <SectionHeading
                                    title="Advantages of DelveInsight’s Coverage"
                                    
                                    customClass='text-left'
                                />
                                    <ul className="listBox">
                                        {data.listPoints.map((item, index) => (
                                            <li key={index} className="flex items-start mb-2">
                                                <span className="flex justify-center items-center w-[1.1rem] h-[1.1rem] text-xs px-2 bg-[#1DA1F2] dark:bg-gray-600 rounded-full mt-1">
                                                    <i className="text-white fa fa-angle-right"></i>
                                                </span>
                                                <span className='pl-2'>{item?.itemPoint}</span>
                                            </li>
                                        ))}
                                    </ul>
                            </div>
                        </div>
                    </section>
                </>
            }
        </>
    )
}
